<div class="wrapper">
    <ng-content></ng-content>
</div>
<div class="wrapper-footer">
    <button kendoButton class="btn btn-secondary" *ngIf="showVorabCheck" (click)="dispatch('vorabCheck')">
        <span translate>
            description.ai.check
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="height: 1.3rem; width: 1.3rem;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
            </svg>
        </span>
    </button>

    <button kendoButton class="btn btn-secondary" *ngIf="showSave" aria-labelledby="saveLabel"  (click)="dispatch('save')">
        <span id="saveLabel" translate>question.save</span>
        <i></i>
    </button>

    <button  kendoButton class="btn btn-primary" *ngIf="showBack" aria-labelledby="backLabel" (click)="dispatch('back')">
        <span id="backLabel" translate>question.back</span>
        <i></i>
    </button>
    
    <button kendoButton class="btn btn-primary" *ngIf="showNext" aria-labelledby="nextLabel"  (click)="dispatch('next')">
        <span id="nextLabel" translate>question.next</span>
        <i></i>
    </button>
</div>